import TaxonomyFilterListEntry from '../../../../../../../components/Blocks/Search/TaxonomyFilterListEntry';

export default TaxonomyFilterListEntry;
